<template>
  
 <div class="container">
      <h3 class="heading">الحي</h3>

      <form @submit.prevent="postinfo">
          <div class="mb-3 input-in-con">
            <div v-if="err">
  <div v-if="err.name_ar"  class="alert alert-danger" role="alert"> {{ err.name_ar[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">اسم الحي</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل اسم الحي " v-model="formdata.name_ar" >
</div>
      
 
      <div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.city"  class="alert alert-danger" role="alert"> {{ err.city[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">المدينة</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.city" >
  <option disabled selected>اختر المدينة</option>
  <option  v-for="key in formdata2" :value="key.id" >{{key.name_ar}}</option>
</select>
</div>


<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>

</template>

<script>

import  geturl  from "@/comp/geturl";

export default {

name:'AddCountry',
data(){
  return{
     formdata:{
      city_name: '',
      name_ar: '',
      city: null,
    },
     formdata2:null,
     temformdata2:null,
    err:null

  }
},

mounted(){


       fetch(geturl()+"city/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data
      
      })
    

},
  methods:{
      postinfo(){

     /*    this.temformdata2 = this.formdata2.filter((e) => {
        return e.name === this.formdata.city_name
      })
     if(this.temformdata2.length>0)
       this.formdata.city = this.temformdata2[0].id  */
      
         fetch(geturl()+"district/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(this.formdata)
      })
      .then(res => res.json())
      .then(data => { if(data.error){
      this.err = data.error.details
      }
      else
            this.$router.push({name:'districtView' })
      }) 
      }


  }

}
</script>

<style>

</style>